import * as React from "react";
const SvgFiRrExpense = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-expense_svg__a)">
      <path
        fill="#062147"
        d="M23.018 8.785a2.97 2.97 0 0 0-2.169-.782 2.98 2.98 0 0 0-2.085.981l-3.217 3.534a3.15 3.15 0 0 0-2.689-1.519H9.001v-1h.376a2.627 2.627 0 0 0 2.624-2.624 2.616 2.616 0 0 0-2.193-2.588l-3.285-.548a.625.625 0 0 1 .103-1.24H9.27c.356 0 .688.192.867.5a.998.998 0 1 0 1.73-1.001 3.01 3.01 0 0 0-2.598-1.5h-.268a1 1 0 1 0-2 0h-.376a2.627 2.627 0 0 0-2.624 2.624c0 1.288.923 2.377 2.193 2.588l3.285.548a.625.625 0 0 1-.103 1.24H6.732c-.356 0-.688-.192-.867-.5a.997.997 0 0 0-1.366-.365A1 1 0 0 0 4.135 8.5a3.01 3.01 0 0 0 2.598 1.499h.268v1h-3c-2.206 0-4 1.794-4 4v5c0 2.206 1.794 4 4 4h4.965c2.85 0 5.57-1.22 7.467-3.348l6.804-7.637a3.02 3.02 0 0 0-.218-4.23zm-1.275 2.899-6.805 7.638A8 8 0 0 1 8.965 22H4c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h8.857c.63 0 1.143.512 1.143 1.142a1.15 1.15 0 0 1-.98 1.131l-5.161.737a1 1 0 1 0 .283 1.979l5.161-.737a3.16 3.16 0 0 0 2.514-2.058l4.427-4.865c.181-.2.43-.316.699-.329.271-.007.528.082.728.262.407.372.44 1.009.072 1.421zm-8.742-7.668a1 1 0 0 1 1-1h4.076L16.787 1.7A1 1 0 1 1 18.215.3l2.177 2.221c.391.39.609.917.609 1.479a2.1 2.1 0 0 1-.616 1.487l-2.17 2.213c-.195.2-.455.3-.714.3a1.001 1.001 0 0 1-.714-1.701l1.258-1.284h-4.044a1 1 0 0 1-1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-expense_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrExpense;
